<template>
<div class="hl-group-box" :class="{}">
  <div class="group-details" v-if="video.allVideos.length && !noPpatt">
    This subscription includes access to {{ video.allVideos.length }} videos
  </div>
  <div class="vid-subsc-box">
    <template v-if="noPpatt">
      <div class="option option-one">
        <p>this {{ introPhotoUrl?'content':'video' }} is available only to PPATT members</p>
        <a class="buy-btn buy-btn-one" href="" v-on:click.prevent="">Request access</a>
      </div>
    </template>
    <template v-else>
      <div class="option" v-if="video.priceUsd*1">
        <p>1 day for <em>{{ formatPriceP(video.priceUsd) }}</em></p>
        <a class="buy-btn" href="" v-on:click.prevent="selectVid(0)">Subscribe</a>
      </div>
      <div class="option" v-if="video.price1*1">
        <p>3 days for <em>{{ formatPriceP(video.price1) }}</em></p>
        <a class="buy-btn" href="" v-on:click.prevent="selectVid(1)">Subscribe</a>
      </div>
      <div class="option" v-if="video.price2*1">
        <p>7 days for <em>{{ formatPriceP(video.price2) }}</em></p>
        <a class="buy-btn" href="" v-on:click.prevent="selectVid(2)">Subscribe</a>
      </div>
      <div class="option" v-if="video.price3*1">
        <p>30 days for <em>{{ formatPriceP(video.price3) }}</em></p>
        <a class="buy-btn" href="" v-on:click.prevent="selectVid(3)">Subscribe</a>
      </div>
      <div class="option" v-if="video.price4*1">
        <p>90 days for <em>{{ formatPriceP(video.price4) }}</em></p>
        <a class="buy-btn" href="" v-on:click.prevent="selectVid(4)">Subscribe</a>
      </div>
    </template>
  </div>
  <div class="or" v-if="!noPpatt">or</div>
  <div class="pkg-subsc-box" v-if="!noPpatt">
    <p class="msg">subscribe to a package that includes all {{ video.type.title }} videos</p>
    <router-link v-on:click.native="goToSubscribe" :to="{name: 'packages'}" class="buy-btn">Subscribe</router-link>
  </div>
</div>
</template>

<script>
import api from './api';
import formatters from './formatters';
import payment from './payment';
export default {
  mixins: [formatters, payment],
  props: ["group", "video", "video2", "noPpatt"],
  data: ()=>({
    userProfile: {},
    videoPayment: null,
    typePayment: null,
  }),
  computed: {
    isExpired() {
      return !!(this.videoPayment || this.typePayment);
    }
  },
  methods: {
    goToSubscribe() {
      window.videoType=this.video.type && this.video.type.id;
    },
    introPhotoUrl() {
      var media=this.item.media;
      if (!media || !media.store || media.store.plugin!="Local")
        return null;
      return media.store.rootUrl+media.path;
    },
    mediaUrl(obj) {
      if (!obj)
        return null;
      var rootUrl="";
      if (obj.store && obj.store.rootUrl)
        rootUrl=obj.store.rootUrl;
      if (obj.thumbnail)
        return rootUrl+obj.path.replace(/\/[^/]*$/, "/")+obj.thumbnail;
      else
        return rootUrl+obj.path;
    },
    textToHtml(text) {
      text=(text || "")+"";
      text=text.replace(/\n/g, "<br />");
      return text;
    },
    selectVid(variant) {
        appCart.pushItem("v", this.video.id, variant);
    },
  },
  mounted() {
  },
}
</script>
